





































/* Created- 16 - May - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IArticle } from "../../../Models/ArticleModels/article";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";
import { ArrayUtils } from "../../../BusinessServices/arrayutils";
import { ButtonConfig, ButtonStatus } from "../../../Models/Buttons";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { DateUtils } from "../../../BusinessServices/dateutils";

@Component(
	{
		name: "ArticleTable",
		components: { ButtonList }
	})
export default class ArticleTable extends Vue {
	@Prop() private data: IArticle[];
	@Prop() private selectedbuttons: ButtonConfig[];
	private selected: IArticle[] = [];
	private search: string = "";
	private headers: any = [
		{ text: "Title", value: "title" },
		{ text: "Publication", value: "issue.pubname" },
		{ text: "Article Type", value: "articleType" },
		{ text: "Date", value: "articleDate" },
	];

	@Watch("selected")
	private buttoncheck() {
		if (this.selected.length > 0) {
			this.selectedbuttons.forEach(button => {
				button.status = ButtonStatus.Enabled;
			});
		} else {
			this.selectedbuttons.forEach(button => {
				button.status = ButtonStatus.Disabled;
			});
		}
	}

	private select(item: IArticle) {
		this.$emit("partica-event", { action: eParticaAction.LEFT_MOUSE_CLICK, item } as ParticaEvent);
	}
	private right(item: IArticle) {
		this.$emit("partica-event", { action: eParticaAction.RIGHT_MOUSE_CLICK, item } as ParticaEvent);
	}
	private selectArticle(item: IArticle, value: any) {
		item.selected = value;
		if (item.selected) {
			this.selected.push(item);
		} else {
			this.selected = ArrayUtils.remove(this.selected, item);
		}
	}
	private checkselect(checked: any) {
		this.data.forEach(article => {
			article.selected = false;
		});
		this.selected = checked;
		this.selected.forEach(row => {
			row.selected = true;
		});
	}

	private selectAction(event: ParticaEvent) {
		event.item = this.selected;
		this.$emit("partica-event", event);
	}

	private getDate(date: Date) {
		return DateUtils.FormatDate(date, "YYYY-MMM-DD");
	}
}
